import { Routes } from '@angular/router';
import { LandingResolver } from '@data/resolvers/landing.resolver';
import { paymentResolver } from '@shared/resolver/payment.resolver';

export const routes: Routes = [
    {
        path: 'roaming',
        loadComponent: ()=> import('./presentations/pages/roaming/roaming.component').then(c => c.RoamingComponent),
        children: [
            {
                path: 'set-schedule/:type/:mlid', // ROAMING TYPE : btl or store
                loadComponent: () => import('./presentations/pages/roaming/pages/set-schedule/set-schedule.component').then(c => c.SetScheduleComponent)
            },
            {
                path: 'checkout/:mlid',
                loadComponent: () => import('./presentations/pages/roaming/pages/checkout/checkout.component').then(c => c.CheckoutComponent)
            }
        ]
    },
    {
        path: 'error/:errorCode',
        loadComponent: () => import('./presentations/pages/dynamic-error/dynamic-error.component').then(c => c.DynamicErrorComponent)
    },
    {
        path: 'invoice-claim/:status',
        loadComponent: () => import('./presentations/pages/invoice-claim-voucher/invoice-claim-voucher.component').then(c => c.InvoiceClaimVoucherComponent)
    },
    {
        path: 'payment/:bid/:content',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'method'    
            },
            {
                path: 'method',
                loadComponent: () => import('./presentations/pages/payment/pages/select-payment-method/select-payment-method.component').then(c => c.SelectPaymentMethodComponent),
                resolve: {
                    payment: paymentResolver
                }
            },
            {
                path: 'ewallet/:bankName',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'detail'
                    },
                    {
                        path: 'detail',
                        loadComponent: () => import('./presentations/pages/payment/pages/ewallet-payment/ewallet-payment.component').then(c => c.EwalletPaymentComponent),
                        resolve: {
                            payment: paymentResolver
                        }
                    },
                    {
                        path: 'processing/:transactionId',
                        loadComponent: () => import('./presentations/pages/payment/pages/ewallet-payment/pages/ewallet-processing/ewallet-processing.component').then(c => c.EwalletProcessingComponent)
                    }
                ]
            },
            {
                path: 'va/:transactionId',
                loadComponent: () => import('./presentations/pages/payment/pages/va-detail/va-detail.component').then(c => c.VaDetailComponent)
            },
            {
                path: 'status/:transactionId',
                loadComponent: () => import('./presentations/pages/payment/pages/payment-status/payment-status.component').then(c => c.PaymentStatusComponent)
            }
        ]
    },
    {
        path: ':content',
        loadComponent: () => import('./presentations/pages/landing/landing.component').then(c => c.LandingComponent),
        resolve: {
            content: LandingResolver
        }
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'error/not-found'
    }
];
